import strings from '../../strings/strings.json'
import { Input } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { CircularProgress } from '@mui/material';

interface Props {
    data: any,
    onCancelModal: () => void
    confirmConnectToWifi: (ssid: string, password: string) => void
}
export default function ConnectWifi(props: Props) {
    const dispatch = useDispatch();
    const [value, setValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const passOnChange = (e: any) => {
        setValue(e.target.value)
    }

    const confrimHandler = () => {
        if (value.length !== 0) {
            setIsLoading(true)
            props.confirmConnectToWifi(props.data.ssid, value)
        } else {
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.public_invalidPassword}` }));
        }
    }

    return (
        <div>
            <div dir="ltr" className='flex flex-col items-center justify-center border-b pb-5 border-b-gray-200'>
                <div className='flex flex-col items-center pb-5 w-full border-b border-b-gray-200'>
                    <span className='primary_text_color text-lg font-medium'>{strings.internet_wifi_detail_title}</span>
                    <span className='secondry_text_color text-xs'>{strings.internet_wifi_detail_subTitle}</span>
                </div>
                <div className="text-center font-medium mt-2"><div className='w-24 truncate'>{props.data.essid}</div></div>
                <div className='mt-5'><Input className='text-right' type="password" placeholder={strings.public_password} onChange={passOnChange} /></div>
            </div>
            <div className='flex justify-around mt-5'>
                <button className='text-white w-28 rounded-full px-8 py-2 primary_bg_color text-xs' onClick={() => !isLoading && confrimHandler()}>
                    {isLoading ? <CircularProgress size={15} color="inherit" /> : <span>{strings.public_confirm}</span>}
                </button>
                <button className='rounded-full w-28 border border-black px-8 py-2 text-xs' onClick={() => props.onCancelModal()}> {strings.public_cancel}</button>
            </div>
        </div >
    )
}
